import { render } from "./ModalVotacionMiNombreEs.vue?vue&type=template&id=1c3c6d72"
import script from "./ModalVotacionMiNombreEs.vue?vue&type=script&lang=js"
export * from "./ModalVotacionMiNombreEs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__